import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { GroupDetail } from "./components/GroupDetail";
import { GroupsContainer } from "./components/groups.container";

function GroupDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.admin.groups.detail);
  const navigate = useNavigate();
  return (
    <Suspense fallback={<PageLoading />}>
      <GroupDetail groupId={id} onBack={() => navigate("..")} />
    </Suspense>
  );
}

export function GroupsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<GroupsContainer />} />
        <Route path=":id" element={<GroupDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
